const findUrl = (record, mobileUrls) => mobileUrls.find(url => url.id === record.id)

export const getTableColumns = additionalProps => {

    const { mobileUrls } = additionalProps;

    return [
        {
            title: "backoffice.campaigns.name",
            dataIndex: "name",
            mobileLevel: 1,
            render: (_, record) => findUrl(record, mobileUrls)?.name ?? ""
        },

        {
            title: "backoffice.campaigns.url",
            dataIndex: "url",
            mobileLevel: 2,
            render: (_, record) => {
                const url = findUrl(record, mobileUrls);
                if(!url) return "";
                const value = url.url;
                return (
                    <span 
                        className="rt--title rt--font-normal rt--font-regular rt--table-col-link"
                        onClick={() => window.open( value,"_blank")}
                    >
                        <b>{ value }</b>
                    </span>
                )
            }
        }
    ]
}
